export default __webpack_public_path__ + "static/media/alert-error.ec89b918.svg";